module.exports = __webpack_public_path__ + "img/AV.9e22a744.png";